/* eslint-disable react/no-unknown-property */
/* eslint-disable max-lines */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable max-statements */
/* eslint-disable no-use-before-define */
import React, { useState, useEffect } from 'react'
import moment from 'moment'

import { bool, object, string } from 'prop-types'
import Card from '@taglivros/oef_componentes/build/components/card'
import styled from 'styled-components'
import { navigate } from '@reach/router'
import { useGlobal } from '../../../contexts/GlobalContext'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import { ReactComponent as LogoCuradoriaIcon } from '../../../assets/icons/Logo_curadoria.svg'
import { ReactComponent as LogoIneditosIcon } from '../../../assets/icons/logo_ineditos.svg'
import { ReactComponent as CalendarIcon } from '../../../assets/icons/calendar.svg'
import { ReactComponent as DollarIcon } from '../../../assets/icons/dollar.svg'
import { ReactComponent as CheckCircleIcon } from '../../../assets/icons/check-circle.svg'
import { ReactComponent as AlertIcon } from '../../../assets/icons/alert-circle.svg'
import { ReactComponent as XCircleIcon } from '../../../assets/icons/x-circle.svg'
import { ReactComponent as Gift } from '../../../assets/icons/gift.svg'
import { ReactComponent as Book } from '../../../assets/icons/book-open.svg'
import { SolicitacaoCancelamentoProvider } from '../../../contexts/SolicitacaoCancelamentoContext'
import RenewPlan from '../../../components/RenewPlan/RenewPlan'
import { useCartaoCredito } from '../../../contexts/CartaoCreditoContext'
import {
  AGUARDANDO_CANCELAMENTO_STATUS,
  ASSINE_PLANO_ANUAL_TITULO,
  CONTINUE_DESCRICAO,
  CONTINUE_TITULO,
  REATIVAR_DESCRICAO,
  RENOVAR_PLANO_TITULO,
  SOLICITOU_CANCELAMENTO_STATUS,
  DESFAZER_CANCELAMENTO_TITULO
} from '../../../components/InformacaoPlano/constantsInformacaoPlano'
import { TIPOS_FLUXO_BRINDES } from '../../../components/FluxosPagamento/constantsFluxosPagamento'
import {
  FLUXOS_PAGAMENTO,
  EVENTOS_GA,
  METODO_PAGAMENTO_BOLETO,
  METODO_PAGAMENTO_PIX,
  PLANO_ANUAL,
  PLANOS_VALIDOS_PARA_UPGRADE,
  ROUTE_BASEPATH,
  STATUS_CANCELADO,
  STATUS_SOLICITOU_CANCELAMENTO,
  URLS,
} from '../../../constants'
import { URLS_APP } from '../../../config'
import { enviaEventoGA } from '../../../utils/helpers/helpersGA'
import { formataDescricaoStatus } from '../../../utils/formatter/formatter'
import { getBrindesPorAcao } from '../../../api/brindes.servico'
import { getInformacoesModalidadePorAssinatura } from '../../../utils/helpers/helpersAssinatura'
import { isEmptyObject, objetoTemPropriedade } from '../../../utils/helpers/helpers'
import StatusEntrega from '../../../components/StatusEntrega/StatusEntrega'
import RenovacaoAutomatica from '../../../containers/Home/components/RenovacaoAutomatica'
import './style.css'
import PendingPix from '../../../components/PendingPix/PendingPix'
import { getTextoDescontoUpgradePlano } from '../../../utils/helpers/helperPlano'

const Container = styled.div`
  width: 100%;

  .card {
    padding: 0 !important;
  }
`

const WrapperContent = styled.div`
`

const Titulo = styled.h2`
  margin: 0;
  display: flex;
  align-items: center;
  padding-left: 16px;
  @media (max-width: 339px) {
    flex: 2;
  }
`

const CardHeader = styled.div`
  margin: 0 30px;
  display: flex;
  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    margin: 0 20px;
  }
  @media (max-width: 339px) {
    margin: 0 0 0 20px;
  }
`

const SeeMore = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: flex-end;

  span {
    font-weight: bold;
    font-size: 14px;
    text-decoration-line: underline;
    color: ${( { isCuradoria } ) => isCuradoria ? '#009BBF' : '#EB8100'};
    cursor: pointer;
    @media (max-width: 339px) {
      padding-right: 10px;
      font-size: 11px;
    }
  }
`

const Signature = styled.div`
  margin: 0 30px;
  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      margin: 0 20px;
  }
  p {
    font-weight: 600;
    font-size: 14px;
    padding-left: 19px;
  }

  svg {
    margin-left: 3px;
  }

  .Ativo {
    display: flex;
    align-items: center;
    p {
      color: #347A0B;
    }
    svg {
      filter: invert(31%) sepia(77%) saturate(1719%) hue-rotate(70deg) brightness(88%) contrast(91%);
    }
  }

  .Suspenso {
    display: flex;
    align-items: center;
    p {
      color: #936A03
    }
    svg {
      filter: invert(32%) sepia(80%) saturate(2243%) hue-rotate(37deg) brightness(93%) contrast(98%);
    }
  }

  .Cancelado {
    display: flex;
    align-items: center;
    p {
      color: #B72133
    }
    svg {
      filter: invert(35%) sepia(95%) saturate(3921%) hue-rotate(335deg) brightness(71%) contrast(103%);
    }
  }

  .Solicitou.Cancelamento {
    display: flex;
    align-items: center;
    p {
      color: #B72133
    }
    svg {
      filter: invert(35%) sepia(95%) saturate(3921%) hue-rotate(335deg) brightness(71%) contrast(103%);
    }
  }
`

const WrapperCalendarBox = styled.div`
  margin: 0 30px;
  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
     margin: 0 20px;
  }
  height: 30px;
  display: flex;
  align-items: center;
  color: #343A4F;

  svg {
    margin-left: 3px;
  }

  p {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    padding-left: 20px;
  }
`

const WrapperWaitingPayment = styled.div`
  margin: 0 30px;
  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
     margin: 0 20px;
  }
  display: flex;
  align-items: center;
  color: #343A4F;

  svg {
    margin-left: 3px;
    filter: invert(35%) sepia(95%) saturate(3921%) hue-rotate(335deg) brightness(71%) contrast(103%);
  }

  p {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    padding-left: 20px;
    color: #B72133
  }
`

const ProcessingOrderLabel = styled.p`
  padding: 30px;
  margin: 0px;
  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    padding: 0 20px 20px 24px;
  }
`

export function getNextRenovacaoData( dataProximaRenovacaoAutomatica ) {
  if ( dataProximaRenovacaoAutomatica ) {
    const formatData = dataProximaRenovacaoAutomatica
      .replace( '(', '' )
      .replace( ')', '' )
    const splitedData = formatData.split( '-' )
    return `${splitedData[ 1 ]}/${splitedData[ 0 ]}`
  }
  return ''
}

const CardAssinatura = ( {
  assinatura,
  modalidade,
  dadosGlobaisAssociado,
  verMaisUrl = '',
  showEnvios,
  showSaibaMais
} ) => {
  const {
    getDadosGlobaisAssociado,
    setNroRenovacoesPorAssinatura,
    nroRenovacoesPorAssinatura,
    setDataProximaRenovacaoAutomatica
  } = useGlobal()
  const [ mensagem, setMensagem ] = useState()
  const [
    oferecerCancelarSolicitacaoCancelamento,
    setOferecerCancelarSolicitacaoCancelamento
  ] = useState()
  const [ modalidadePorAssinatura, setModalidadePorAssinatura ] = useState()
  const [ temCobrancaBoletoPendente, setTemCobrancaBoletoPendente ] = useState()
  const [ temCobrancaPixPendente, setTemCobrancaPixPendente ] = useState()
  const [ status, setStatus ] = useState()
  const [ plano, setPlano ] = useState()
  const [ imagemRenovacao, setImagemRenovacao ] = useState()
  const [ imagemUpgrade, setImagemUpgrade ] = useState()
  const { infosPagamento, getInfosPagamento } = useCartaoCredito()

  useEffect( () => {
    getInfosPagamento( assinatura.id )
  }, [] )

  const fetchImagemBrinde = async fluxoPagamento => {
    const setImagem = urlImagem => {
      switch ( fluxoPagamento ) {
        case TIPOS_FLUXO_BRINDES[ FLUXOS_PAGAMENTO.RENOVACAO ]:
          return setImagemRenovacao( urlImagem )
        case TIPOS_FLUXO_BRINDES[ FLUXOS_PAGAMENTO.UPGRADE ]:
          return setImagemUpgrade( urlImagem )
        default:
          return () => {}
      }
    }
    try {
      const [ letraInicialPlanoAnual ] = PLANO_ANUAL.visualizacao
      const response = await getBrindesPorAcao(
        fluxoPagamento,
        modalidadePorAssinatura.id,
        letraInicialPlanoAnual
      )

      if ( response.data && response.data.length === 1 ) {
        setImagem( response.data[ 0 ].imagemURL )
      }

      setNroRenovacoesPorAssinatura( {
        ...nroRenovacoesPorAssinatura,
        [ modalidadePorAssinatura.slug ]: response.data[ 0 ].nroRenovacoes
      } )
    } catch ( erro ) {
      setImagem( null )
    }
  }

  function renderSignatureStatusIcon() {
    switch ( status ) {
      case 'Ativo':
        return <CheckCircleIcon />
      case 'Suspenso':
        return <AlertIcon />
      case 'Cancelado':
        return <XCircleIcon />
      case 'Solicitou Cancelamento':
        return <XCircleIcon />
      default:
        return ''
    }
  }

  function isCuradoria() {
    return modalidadePorAssinatura?.visualizacao === 'Curadoria'
  }

  function renderFlag() {
    if ( isCuradoria() ) {
      return <LogoCuradoriaIcon />
    }
    return <LogoIneditosIcon />
  }

  function verifyIfLastOrderIsJun2022() {
    if ( plano === 'Mensal' || plano === 'Trimestral' ) {
      return true
    }
    if ( status !== 'Ativo' ) {
      return true
    }
    const ultimoPedido = assinatura?.controles?.mesTagUltimoPedidoValido
    if ( !ultimoPedido ) {
      return false
    }
    const formatData = ultimoPedido.replace( '(', '' ).replace( ')', '' )
    const splitedData = formatData.split( ',' )
    if (
      splitedData[ 0 ] === '2022' &&
      ( splitedData[ 1 ] === '06' || splitedData[ 1 ] === '6' )
    ) {
      return true
    } else {
      return false
    }
  }

  function getValidDates() {
    const day15 = moment(
      `15/${getNextRenovacaoData( assinatura?.dataProximaRenovacaoAutomatica )}`,
      'DD/MM/YYYY'
    )
    const day25 = moment(
      `25/${getNextRenovacaoData( assinatura?.dataProximaRenovacaoAutomatica )}`,
      'DD/MM/YYYY'
    )
    const itens = []

    if ( moment().isBefore( day15 ) ) {
      itens.push( {
        'codigo': '15',
        'value': '15',
        'visualizacao': '15'
      } )
    }
    if ( moment().isBefore( day25 ) ) {
      itens.push( {
        'codigo': '25',
        'value': '25',
        'visualizacao': '25'
      } )
    }
    return itens
  }

  useEffect( () => {
    if (
      mensagem &&
      mensagem.acao === RENOVAR_PLANO_TITULO &&
      !mensagem.imgUrl
    ) {
      setMensagem( { ...mensagem, 'imgUrl': imagemRenovacao } )
    }
  }, [ imagemRenovacao ] )

  useEffect( () => {
    if (
      mensagem &&
      mensagem.acao === ASSINE_PLANO_ANUAL_TITULO &&
      !mensagem.imgUrl
    ) {
      setMensagem( { ...mensagem, 'imgUrl': imagemUpgrade } )
    }
  }, [ imagemUpgrade ] )

  useEffect( () => {
    if (
      !isEmptyObject( assinatura ) &&
      objetoTemPropriedade( assinatura, 'modalidade' ) &&
      assinatura.modalidade
    ) {
      const infoModalidade = getInformacoesModalidadePorAssinatura( assinatura.modalidade )
      setModalidadePorAssinatura( infoModalidade )
    }

    if (
      !isEmptyObject( assinatura ) &&
      objetoTemPropriedade( assinatura, 'plano' )
    ) {
      setPlano( assinatura.plano )
    }

    if (
      !isEmptyObject( assinatura ) &&
      objetoTemPropriedade( assinatura, 'status' )
    ) {
      setStatus( assinatura.status )
    }

    if ( !isEmptyObject( modalidade ) ) {
      setTemCobrancaBoletoPendente( modalidade.temCobrancaBoletoPendente )
      setTemCobrancaPixPendente( modalidade.temCobrancaPixPendente )
    }
  }, [ assinatura, modalidade ] )
  useEffect( () => {
    if ( assinatura.controles && modalidadePorAssinatura ) {
      const { isPresente } = assinatura.controles
      if ( infosPagamento?.podeAutoCobrar ) {
        setMensagem( {
          'acao': 'Regularizar pagamento',
          'color': '#B72133',
          'handleClick': () => navigate( `${ROUTE_BASEPATH}${URLS_APP.BASE_PATH ? '/' : ''}${
            modalidadePorAssinatura.slug
          }/pagamento` ),
          'icon': <AlertIcon />,
          'texto':
            '<strong>O pagamento do mês vigente está em aberto.</strong> Clique no botão abaixo para regularizar sua situação'
        } )
      } else if ( assinatura.controles.podeManter ) {
        setMensagem( {
          'acao': CONTINUE_TITULO,
          'handleClick': () => navigate( `${ROUTE_BASEPATH}${URLS_APP.BASE_PATH ? '/' : ''}${
            modalidadePorAssinatura.slug
          }/${URLS.CONTINUAR_ASSINATURA_PLANO}` ),
          'id-teste': 'botao-home-continue',
          'texto': CONTINUE_DESCRICAO
        } )
      } else if (
        assinatura.controles.podeRenovar &&
        !isPresente &&
        !temCobrancaBoletoPendente &&
        !temCobrancaPixPendente
      ) {
        fetchImagemBrinde( TIPOS_FLUXO_BRINDES[ FLUXOS_PAGAMENTO.RENOVACAO ] )
        setMensagem( {
          'acao': RENOVAR_PLANO_TITULO,
          'handleClick': () => {
            enviaEventoGA(
              EVENTOS_GA.RENOVACAO.FLUXO,
              EVENTOS_GA.RENOVACAO.ACOES.INIT
            )
            navigate( `${ROUTE_BASEPATH}${URLS_APP.BASE_PATH ? '/' : ''}${
              modalidadePorAssinatura.slug
            }/${URLS.PLANO}/${URLS.RENOVAR_PLANO_ENTREGA}` )
          },
          'icon': <Gift />,
          'id-teste': 'botao-home-renovacao',
          'imgUrl': mensagem?.imgUrl,
          'texto':
            'Seu plano anual está chegando ao fim, <strong>renove e ganhe um brinde exclusivo!</strong>'
        } )
      } else if (
        !isPresente &&
        plano &&
        status &&
        !temCobrancaBoletoPendente &&
        !temCobrancaPixPendente
      ) {
        const planoPermiteUpgrade = PLANOS_VALIDOS_PARA_UPGRADE.some( infoPlano => infoPlano.visualizacao === plano )
        const cancelado = status === STATUS_CANCELADO
        if ( planoPermiteUpgrade && !cancelado ) {
          fetchImagemBrinde( TIPOS_FLUXO_BRINDES[ FLUXOS_PAGAMENTO.UPGRADE ] )
          setMensagem( {
            'acao': 'Eu quero o plano anual',
            'handleClick': () => {
              enviaEventoGA(
                EVENTOS_GA.UPGRADE.FLUXO,
                EVENTOS_GA.UPGRADE.ACOES.INIT
              )
              navigate( `${ROUTE_BASEPATH}${URLS_APP.BASE_PATH ? '/' : ''}${
                modalidadePorAssinatura.slug
              }/${URLS.PLANO}/${URLS.UPGRADE_ENTREGA}` )
            },
            'icon': <Gift />,
            'id-teste': 'botao-home-upgrade',
            'imgUrl': mensagem?.imgUrl,
            'testId': 'plano-anual',
            'texto': getTextoDescontoUpgradePlano( modalidadePorAssinatura.slug, plano, PLANO_ANUAL.slug )
          } )
        }
      } else if ( temCobrancaBoletoPendente ) {
        setMensagem( {
          'acao': 'Acessar boleto',
          'color': '#B72133',
          'handleClick': () => navigate( temCobrancaBoletoPendente.boleto_url ),
          'icon': <AlertIcon />,
          'texto': `<strong> ${getMessageBoleto()} </strong>`
        } )
      }
    }
  }, [
    assinatura.controles,
    modalidadePorAssinatura,
    infosPagamento,
    temCobrancaBoletoPendente,
    temCobrancaPixPendente
  ] )

  function getMessageBoleto() {
    const { origem } = temCobrancaBoletoPendente
    return getMessage( origem, METODO_PAGAMENTO_BOLETO.slug )
  }

  function getMessagePix() {
    return getMessage( temCobrancaPixPendente?.origem, METODO_PAGAMENTO_PIX.slug )
  }

  function getMessage( origem, metodoPagamento ) {
    if ( origem === 'UPGRADE_PLANO' ) {
      return `Existe um ${metodoPagamento} referente ao upgrade para o plano anual aguardando pagamento.`
    }
    if ( origem === 'REATIVACAO' ) {
      return `Existe um ${metodoPagamento} referente à reativação do plano anual aguardando pagamento.`
    }
    return `Existe um ${metodoPagamento} referente à renovação do plano anual aguardando pagamento.`
  }

  useEffect( () => {
    if ( status && modalidadePorAssinatura ) {
      if ( status === STATUS_CANCELADO ) {
        setMensagem( {
          'acao': REATIVAR_DESCRICAO,
          'handleClick': () => {
            enviaEventoGA(
              EVENTOS_GA.REATIVACAO.FLUXO,
              EVENTOS_GA.REATIVACAO.ACOES.INIT
            )
            navigate( `${ROUTE_BASEPATH}${URLS_APP.BASE_PATH ? '/' : ''}${
              modalidadePorAssinatura.slug
            }/${URLS.PLANO}/${URLS.REATIVAR_ASSINATURA_PLANO}` )
          },
          'icon': <Book />,
          'testId': 'botao-home-reativacao',
          'texto':
            '<strong>Reative a sua assinatura</strong> e volte a viver experiências literárias com a gente'
        } )
      } else if (
        status === SOLICITOU_CANCELAMENTO_STATUS ||
        status === AGUARDANDO_CANCELAMENTO_STATUS
      ) {
        setOferecerCancelarSolicitacaoCancelamento( true )
      }
    }
    if ( status === STATUS_SOLICITOU_CANCELAMENTO ) {
      setMensagem( {
        'acao': DESFAZER_CANCELAMENTO_TITULO,
        'icon': <Book />,
        'texto':
          '<strong>Desistiu de cancelar? </strong>Você pode desfazer o cancelamento clicando abaixo'
      } )
    }
    if ( temCobrancaBoletoPendente ) {
      setMensagem( {
        'acao': 'Acessar boleto',
        'color': '#B72133',
        'handleClick': () => navigate( temCobrancaBoletoPendente.boleto_url ),
        'icon': <AlertIcon />,
        'texto': `<strong> ${getMessageBoleto()} </strong>`
      } )
    }
  }, [ modalidadePorAssinatura, status ] )

  return (
    <Container>
      <Card
        className="card"
        largura="100%"
        margin="0 0 0 0"
        padding="0 0 20px 0"
      >
        <CardHeader>
          {renderFlag()}

          {modalidadePorAssinatura ? <Titulo>{modalidadePorAssinatura.titulo}</Titulo> : null}

          <SeeMore
            isCuradoria={ isCuradoria() }
            onClick={ () => navigate( verMaisUrl ) }
          >
            <span testId="vermais-home">Ver mais</span>
          </SeeMore>
        </CardHeader>

        <WrapperContent>
          <Signature>
            <div className={ status }>
              {renderSignatureStatusIcon()}

              {assinatura && status ? <p>{formataDescricaoStatus( status )}</p> : null}
            </div>
          </Signature>

          {( infosPagamento?.podeAutoCobrar || assinatura?.controles?.falhaAoAtualizar ) ?
            <WrapperWaitingPayment>
              <DollarIcon />

              <p>Aguardando pagamento</p>
            </WrapperWaitingPayment> : null}

          <WrapperCalendarBox>
            <CalendarIcon />

            {assinatura && plano ? <p>{`Plano ${assinatura.plano.toLowerCase()}`}</p> : null}
          </WrapperCalendarBox>
        </WrapperContent>

        {verifyIfLastOrderIsJun2022() ? (
          mensagem &&
          status !== 'Suspenso' && (
            <SolicitacaoCancelamentoProvider>
              <RenewPlan
                getDados={ () => getDadosGlobaisAssociado }
                mensagem={ mensagem }
                oferecerCancelarSolicitacaoCancelamento={
                  oferecerCancelarSolicitacaoCancelamento
                }
                tituloModalidade={ modalidadePorAssinatura.slug }
                type={ modalidadePorAssinatura?.visualizacao }
              />
            </SolicitacaoCancelamentoProvider>
          )
        ) : (
          <RenovacaoAutomatica
            assinatura={ assinatura }
            dadosGlobaisAssociado={ dadosGlobaisAssociado }
            isCuradoria={ isCuradoria() }
            nextdata={ getNextRenovacaoData( assinatura?.dataProximaRenovacaoAutomatica ) }
            podeRenovar={ assinatura?.controles?.podeRenovar }
            setDataProximaRenovacaoAutomatica={
              setDataProximaRenovacaoAutomatica
            }
            showSaibaMais={ showSaibaMais }
            validDates={ getValidDates() }
          />
        )}

        <PendingPix
          message={ getMessagePix() }
          pixData={ temCobrancaPixPendente }
        />

        {showEnvios ?
          <>
            {assinatura && objetoTemPropriedade( assinatura, 'ultimoPedido' ) ? (
              <StatusEntrega ultimoPedido={ assinatura.ultimoPedido } />
            ) : (
              <ProcessingOrderLabel>
                <strong>Processando seu pedido...</strong>
              </ProcessingOrderLabel>
            )}
          </> : null}
      </Card>
    </Container>
  )
}

CardAssinatura.propTypes = {
  'assinatura': object.isRequired,
  'dadosGlobaisAssociado': object.isRequired,
  'modalidade': object.isRequired,
  'showEnvios': bool.isRequired,
  'showSaibaMais': bool.isRequired,
  'verMaisUrl': string.isRequired
}

export default CardAssinatura
